module.exports = __webpack_public_path__ + "static/media/comercial.d6006e16.png";